import axios from "axios"
import React, { useEffect, useMemo, useState } from "react"
import { removeItemFromCart } from "../../util/util"
import "../layout.css"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

export default function Cart(props) {
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [cartItems, setCartItems] = useState([])
  const [total, setTotal] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let cart = JSON.parse(localStorage.getItem("cart"))
    setCartItems(cart)
  }, [])

  useEffect(() => {
    const wakeApi =()=>{
      axios.get("https://etiba-mpesa-api.onrender.com/health").then(res => {
        console.log("API is up")
      }).catch(err => {
        console.log(err)
      })
    }
    wakeApi();
  }, [])

  useMemo(() => {
    let total = 0
    if (cartItems) {
      cartItems.forEach(item => {
        total += item?.price * 1
      })
      setTotal(total)
    }
  }, [cartItems])

  const removeItem = item => {
    try {
      let cart = removeItemFromCart(item)
      setCartItems(cart)
    } catch (e) {
      console.log(e)
    }
  }

  // TODO: fix this function that updates item quantities
  const changeItemQuantity = (e, item) => {
    let cart = cartItems?.filter(cartItem => cartItem.title !== item.title)
    item.quantity = e.target.value
    cart.push(item)
    localStorage.setItem("cart", JSON.stringify(cart))
    setCartItems(cart)
  }

  const checkout = async () => {
    if (isLoading) return
    setIsLoading(true)
    if (cartItems.length === 0) {
      alert("Your cart is empty")
    }
    if (phone.split("").length > 13 || phone.split("").length < 9) {
      console.log(phone.split(""))
      alert("Invalid phone number")
      return
    }
    // get the last 9 digits
    let newPhone = phone.slice(-9)

    var data = JSON.stringify({
      phoneNumber: `254${newPhone}`,
      amount: parseInt(total),
    })

    var config = {
      method: "post",
      url: "https://etiba-mpesa-api.onrender.com/mpesa",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    }
    toast.success('Check your Phone for the Mpesa Prompt!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      });

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data))
      })
      .catch(function (error) {
        console.log(error)
      })

    setIsLoading(false)
  }

  return (
    <div>
      {cartItems?.map(product => {
        return (
          <div
            key={product?.idx}
            className="d-flex flex-row justify-content-between align-items-center pt-lg-4 pt-2 pb-3 border-bottom mobile"
          >
            <div className="d-flex flex-row align-items-center">
              <div>
                <img
                  src={product?.image?.file?.url}
                  alt={product?.title}
                  width="150"
                  height="150"
                  id="image"
                />
              </div>
              <div className="d-flex flex-column pl-md-3 pl-1">
                <div>
                  <h6>{product?.title}</h6>
                </div>
                <div>
                  Art.No:<span className="pl-2">091091001</span>
                </div>
                <div>
                  Color:<span className="pl-3">White</span>
                </div>
                <div>
                  Size:<span className="pl-4"> M</span>
                </div>
              </div>
            </div>
            <div className="pl-md-0 pl-1">
              <b>{product?.price}</b>
            </div>
            <div className="pl-md-0 pl-2">
              <span className="fa fa-minus-square text-secondary"></span>
              <span className="px-md-3 px-1">2</span>
              <span className="fa fa-plus-square text-secondary"></span>
            </div>

            <div onClick={() => removeItem(product)} className="close">
              &times;
            </div>
          </div>
        )
      })}
      <div className="container bg-light rounded-bottom py-4" id="zero-pad">
        <div className="row d-flex justify-content-center">
          <div className="col-lg-10 col-12">
            <div className="d-flex justify-content-between align-items-right">
              <div></div>
              <div className="px-md-0 px-1 pb-3" id="footer-font">
                <b className="pl-md-4">
                  SUBTOTAL<span className="pl-md-4">{total}</span>
                </b>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 col-12">
            <input
              class="form-control"
              placeholder="name"
              value={name}
              onChange={e => {
                setName(e.target.value)
              }}
            />
          </div>

          <div className="col-md-4 col-12">
            <input
              class="form-control"
              placeholder="email"
              value={email}
              onChange={e => {
                setEmail(e.target.value)
              }}
            />
          </div>

          <div className="col-md-4 col-12">
            <input
              class="form-control"
              placeholder="phone number (Mpesa Number)"
              value={phone}
              onChange={e => {
                setPhone(e.target.value)
              }}
            />
          </div>
        </div>
        <button
          onClick={checkout}
          className="btn btn-primary btn-lg btn-block"
          disabled={!phone || isLoading}
        >
          {isLoading ? "Initiating payment..." : "Pay Via Mpesa!"}
        </button>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
